import React, { Suspense, useEffect } from "react";
import styled from "styled-components/macro";
import { ErrorBoundary } from "react-error-boundary";
import { useQuery } from "@apollo/client";
import WorkspaceOrderHeader from "components/Headers/WorkspaceOrderHeader/WorkspaceOrderHeader";
import LoadingContainer from "LoadingContainer";
import Suspender from "lib/Suspender";
import { NotFoundNavigation } from "components/NotFound";
import { WorkspaceNameDoc } from "operations";
import { logger } from "lib/Datadog";

import SummaryBar from "./SummaryBar";
import { ErrorPage } from "./ErrorPage";
import { useWorkspaceId } from "./Routes";
import { useFlags } from "launchdarkly-react-client-sdk";

const FlexContainer = styled.section`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

const FlexContent = styled.section`
  flex: 1;
  overflow: auto;
  margin-top: 16px;
  margin-inline: 22px;
`;

const FlexTabContent = styled.section`
  flex: 1;
`;

export const WorkspaceLayout: React.FC = ({ children }) => {
  const workspaceId = useWorkspaceId();
  const { data, loading } = useQuery(WorkspaceNameDoc, {
    variables: { workspaceId },
  });
  const { workspaceBudgets } = useFlags();
  const FlexComponent = workspaceBudgets ? FlexTabContent : FlexContent;

  useEffect(() => {
    logger.log(JSON.stringify({ data, loading, workspaceId }));
    if (data?.retailWorkspace?.name) {
      document.title = `${data?.retailWorkspace?.name} | JOOR Workspaces`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <Suspender suspend={loading}>
        {!data?.retailWorkspace?.name && <NotFoundNavigation />}
        <FlexContainer>
          <WorkspaceOrderHeader view="workspace" />
          <SummaryBar workspaceId={workspaceId} />
          <FlexComponent>
            <Suspense fallback={<LoadingContainer loading />}>
              {children}
            </Suspense>
          </FlexComponent>
        </FlexContainer>
      </Suspender>
    </ErrorBoundary>
  );
};
